import { useParams } from 'react-router-dom'
import styled from 'styled-components'

import CircleApplyPaymentInfo from '~/features/circle-participation/components/CircleApplyPaymentInfo'
import CircleOptionInfo from '~/features/circle-participation/components/CircleOptionInfo'
import CircleRequiredInfo from '~/features/circle-participation/components/CircleRequiredInfo'
import usePaymentInfoVisibility from '~/features/circle-participation/hooks/usePaymentInfoVisibility'
import { useCircleApplyDetail } from '~/features/circle-participation/queries/useCircleApply'
import LoadingScreen from '~/shared/components/loading/LoadingScreen'

function CircleInfo() {
  const { applicationId } = useParams()

  const { data, isLoading } = useCircleApplyDetail(applicationId!)

  const isPaymentInfoVisible = usePaymentInfoVisibility(
    data?.userBoothApplication.booth_status || '',
  )

  if (isLoading) return <LoadingScreen />

  return (
    <Wrapper>
      {isPaymentInfoVisible && <CircleApplyPaymentInfo data={data!} />}
      <CircleRequiredInfo data={data!} />
      <CircleOptionInfo data={data!} />
    </Wrapper>
  )
}

export default CircleInfo

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
  width: 100%;
`
